module.exports = __webpack_public_path__ + "img/156.c90297c5.jpg";